/// <amd-module name="redux/redux-saga.compat" />

// to be changed to
//   export * as effects from "redux-saga/effects"
// once redux-saga is upgraded to ^1.1.1
export { effects } from "redux-saga";
